export default __webpack_public_path__ + "static/media/about.33645d34.webp";